import { Routes, Route, Navigate } from "react-router-dom";
import { TourProvider } from "@reactour/tour";
import { QuizPage } from "../pages";

export const PatientRoute = () => {
  return (
    <>
      <TourProvider>
        <Routes>
          <Route path="quiz" element={<QuizPage />} />
          <Route path="/*" element={<Navigate to={"quiz"} />} />
        </Routes>
      </TourProvider>
    </>
  );
};
